export class SiteFakeDb
{
    public static sites = [
        {  
            'SiteId':'1000001',
            'ClientId':'1',
            'AccountNum':'429699',
            'SiteType':'Fire Commercial',
            'Company':'BRANDYWINE PORCHE',
            'Address':'4005 WEST CHESTER PKE',
            'City':'Sayre',
            'State':'PA',	
            'ZIP':'18840',
            'Country':'USA',
            'SiteUse':'InUse',
            'PremideID':'12698',
            'Contact':'ZINA WAGNER',
            'PhoneNumber':'6106233908',
            'Email':'zigventures@gmail.com'

         },
         {  
            'SiteId':'1000002',
            'ClientId':'2',
            'AccountNum':'91573',
            'SiteType':'Fire Commercial',
            'Company':'JOHN MIDDLETON',
            'Address':'416 MORRIS AVE',
            'City':'Sayre',
            'State':'PA',	
            'ZIP':'18840',
            'Country':'USA',
            'SiteUse':'InUse',
            'PremideID':'12699',
            'Contact':'ZINA WAGNER1',
            'PhoneNumber':'6106233901',
            'Email':'zigventures@gmail.com'
         },
         {  
            'SiteId':'1000003',
            'ClientId':'3',
            'AccountNum':'91574',
            'SiteType':'Fire Commercial',
            'Company':'JOHN MIDDLETON',
            'Address':'416 MORRIS AVE',
            'City':'Sayre',
            'State':'PA',	
            'ZIP':'18840',
            'Country':'USA',
            'SiteUse':'InUse',
            'PremideID':'12691',
            'Contact':'ZINA WAGNER2',
            'PhoneNumber':'6106233902',
            'Email':'zigventures2@gmail.com'
         },
         {  
            'SiteId':'1000004',
            'ClientId':'4',
            'AccountNum':'91574',
            'SiteType':'Fire Commercial',
            'Company':'JOHN MIDDLETON',
            'Address':'416 MORRIS AVE',
            'City':'Sayre',
            'State':'PA',	
            'ZIP':'18840',
            'Country':'USA',
            'SiteUse':'InUse',
            'PremideID':'12692',
            'Contact':'ZINA WAGNER3',
            'PhoneNumber':'6106233903',
            'Email':'zigventures3@gmail.com'
         },
    ];

}
